/* eslint-disable import/no-default-export */
import { API } from '@/api'
import { login } from '@/utils/native_interactions/login'
export default {
  getPopShop({ state, commit }) {
    return API.pop
      .getShopIndexInfo({
        pop_id: state.shop.id
      })
      .then(res => {
        commit('updateShopInfo', res)
        return res
      })
      .catch(e => {
        if (
          e?.res?.error?.code === 1012002 ||
          e?.res?.error?.code === 2003 ||
          e?.res?.error?.code === 1013014
        ) {
          login()
        }
        if (e?.error?.code === 30000001) {
          commit('updateRiskInfo', {
            ...e.error,
            url: 'pop/getshopindexinfo'
          })
          return Promise.reject(e)
        }
      })
  },
  getSaleClassify({ state }) {
    return API.pop
      .getPopSaleClassify({
        pop_id: state.shop.id
      })
      .then(res => {
        return res
      })
  },
  getGoodsBySaleClass2Id({ state, commit }, { saleClass2Id, size, page }) {
    return API.pop
      .getPopSkuSsuBySaleClass2Id({
        pop_id: state.shop.id,
        sale_class2_id: saleClass2Id,
        size,
        page
      })
      .then(res => {
        return res
      })
      .catch(e => {
        if (e?.error?.code === 30000001) {
          commit('updateRiskInfo', {
            ...e.error,
            url: 'pop/getpopskussubysaleclass2id'
          })
          return Promise.reject(e)
        }
      })
  },
  getPopQualificationInfo({ state, commit }) {
    return API.pop
      .getPopQualificationInfo({ pop_id: state.shop.id })
      .then(res => {
        commit('updateShopQualification', res)
        return res
      })
  },
  getPopQualificationPic({ state, commit }, { verifyId, type }) {
    return API.pop
      .getPopQualificationPic({ pop_id: state.shop.id, verifyId, type })
      .then(res => {
        commit('updateShopQualification', res)
        return res
      })
  },
  getPopPersonalDeclaration({ state, commit }, { verifyId, showBiz }) {
    return API.pop
      .getPopQualificationPic({
        pop_id: state.shop.id,
        verifyId,
        show_biz: showBiz
      })
      .then(res => {
        commit('updatePersonalDeclaration', res)
        return res
      })
  },
  claimCoupon({ commit }, { deliveryId, couponId }) {
    return API.coupon
      .receiveCoupon({
        delivery_id: deliveryId,
        action_id: couponId
      })
      .then(res => {
        return res
      })
  },
  // 根据活动id或优惠券id获得商品所属的一级二级分类
  classInit({ commit }, data) {
    return API.activity.polymerizeSaleClass(data).then(res => {
      if (res) {
        commit('classInit', res)
        return res
      }
      return Promise.reject(res)
    })
  },
  // 根据POPID获取IM群号
  getIMRoom({ commit }, data) {
    return API.im.getIMRoom(data).then(res => {
      if (res) {
        return res
      }
      return Promise.reject(res)
    })
  },
  // 根据活动id/优惠券id获取活动商品列表
  getActivitySkuList({ commit }, data) {
    commit('loadingSwitch', true)
    const options = {
      size: 10
    }
    const params = Object.assign({}, data, options)
    return API.activity.polymerizeProduct(params).then(res => {
      commit('loadingSwitch', false)
      if (res) {
        commit('initeSkuList', res)
        return res
      }
      return Promise.reject(res)
    })
  },
  // 一级分类点击
  class1ListClick({ commit }, { item, index }) {
    if (item.id === 0) {
      commit('navListUpdate', [
        {
          key: 'class2Name',
          value: item.name
        }
      ])
    }
    commit('navListUpdate', [
      {
        key: 'class2List',
        value: item.class2_list
      },
      {
        key: 'classIndex',
        value: index
      }
    ])
  },
  // 二级分类点击
  class2ListClick({ commit }, { item, index }) {
    commit('navListUpdate', [
      {
        key: 'class2Name',
        value: item.name
      },
      {
        key: 'class2Index',
        value: index
      }
    ])
  },
  // 开关筛选区域
  openFilter({ commit }, ifOpen) {
    commit('filterOpen', ifOpen)
  },
  // 选中筛选条件 （促销、排序、筛选三者互斥）
  selectFilter({ commit, state }, { ids, brand }) {
    commit('filterOpen', false)
    commit('filterSelect', ids)
    commit('brandSelect', brand)
  },
  setActQueryData({ commit }, data) {
    commit('setActQueryData', data)
  },
  clearSkuList({ commit }) {
    commit('clearSkuList')
  },
  clearData({ commit }) {
    commit('clearData')
  },
  setFilterSort({ commit }, data) {
    commit('setFilterSort', data)
  },
  clearQueryData({ commit }, data) {
    commit('clearQueryData', data)
  },
  setPrice({ commit }, data) {
    commit('setPrice', data)
  },
  setKeyWord({ commit }, data) {
    commit('setKeyWord', data)
  },
  setSallClass1Id({ commit }, data) {
    commit('setSallClass1Id', data)
  },
  clearClass2Index({ commit }, data) {
    commit('clearClass2Index', data)
  },
  clearStateData({ commit }, data) {
    commit('clearStateData', data)
  },
  clearRiskInfo({ commit }) {
    commit('clearRiskInfo')
  }
}
